'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaShareAlt = function FaShareAlt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.1 22.9q3 0 5.1 2t2.1 5.1-2.1 5.1-5.1 2-5-2-2.1-5.1q0-0.3 0-0.8l-8-4q-2 1.9-4.9 1.9-2.9 0-5-2t-2.1-5.1 2.1-5.1 5-2q2.9 0 4.9 1.9l8-4q0-0.5 0-0.8 0-3 2.1-5.1t5-2 5.1 2 2.1 5.1-2.1 5.1-5.1 2q-2.8 0-4.8-1.9l-8.1 4q0.1 0.5 0.1 0.8t-0.1 0.8l8.1 4q2-1.9 4.8-1.9z' })
        )
    );
};

exports.default = FaShareAlt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/share-alt.js
// module id = 1785
// module chunks = 0